import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteSmokerRateOverrideRulesByFilter } from '../../../api/plan-smoker-rate-override-rules-api'
import type {
  DeleteSmokerRateOverrideRulesByFilterRequestDto,
  DeleteSmokerRateOverrideRulesByFilterResponseDto,
} from '../../../api/dto/plan-smoker-rate-override-rules.dto'
import { SMOKER_RATE_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanSmokerRateOverride/hooks/useGetSmokerRateOverrideRules'

export function useDeleteSmokerRateOverrideRulesByFilter() {
  const queryClient = useQueryClient()

  return useMutation<
    DeleteSmokerRateOverrideRulesByFilterResponseDto,
    unknown,
    DeleteSmokerRateOverrideRulesByFilterRequestDto
  >({
    mutationFn: (params) => deleteSmokerRateOverrideRulesByFilter(params),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [SMOKER_RATE_OVERRIDE_RULES_QUERY_KEY],
      })
    },
  })
}
